import {
  HTTP_UPDATEBUDGETFA_FETCHING,
  HTTP_UPDATEBUDGETFA_SUCCESS,
  HTTP_UPDATEBUDGETFA_FAILED,
  server,
} from "src/Constants";
import Axios from "axios";
import { httpClient } from "src/utils/HttpClient";

//update Budgets
export const setStateupdateBudgetfaToFetching = () => ({
  type: HTTP_UPDATEBUDGETFA_FETCHING,
});

export const setStateupdateBudgetfaToSuccess = (payload) => ({
  type: HTTP_UPDATEBUDGETFA_SUCCESS,
  payload,
});

export const setStateupdateBudgetfaToFailed = (payload) => ({
  type: HTTP_UPDATEBUDGETFA_FAILED,
});

export const updateBudgetfaById = (id, memid, item) => {
  return async (dispatch) => {
    dispatch(setStateupdateBudgetfaToFetching());
    try {
      await httpClient.put(`${server.UPDATEBUDGETFA_URL}/${id}/${memid}`, item);
      dispatch(setStateupdateBudgetfaToSuccess("success"));
    } catch (error) {
      dispatch(setStateupdateBudgetfaToFailed());
    }
  };
};
